import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  currencyRates: null,
  location: { currency: 'INR', country: 'IN' }, // Default values
  loading: false,
  error: null,
};

const apiSlice = createSlice({
  name: "api",
  initialState,
  reducers: {
    setCurrencyRates: (state, action) => {
      state.currencyRates = action.payload;
      state.loading = false;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
      state.loading = false;
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setCurrencyRates,
  setLocation,
  setLoading,
  setError,
} = apiSlice.actions;

// Thunk for fetching currency rates
export const fetchCurrencyRates = createAsyncThunk(
  'api/fetchCurrencyRates',
  async (_, { dispatch }) => {
    try {
      dispatch(setLoading());
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/currency-list`);
      const data = await response.json();
      
      if (data.success) {
        dispatch(setCurrencyRates(data.conversion_rates));
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      dispatch(setError(error.message));
      toast.error("Failed to fetch currency rates");
      throw error;
    }
  }
);

// Thunk for fetching location
export const fetchLocation = createAsyncThunk(
  'api/fetchLocation',
  async (_, { dispatch }) => {
    try {
      dispatch(setLoading());
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}`);
      const data = await response.json();

      if (data.status) {
        // Parse the country string to get city, state, and country code
        const countryParts = data.country.split(': ')[1].split(', '); // ["Mumbai", "MH", "IN"]
        dispatch(setLocation({
          currency: data.currency,
          city: countryParts[0],
          state: countryParts[1],
          country: countryParts[2],
          country_full_name: data.country_full_name
        }));
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      dispatch(setError(error.message));
      // Fallback to default values
      dispatch(setLocation({ 
        currency: 'INR', 
        city: 'Mumbai',
        state: 'MH',
        country: 'IN',
        country_full_name: 'India' 
      }));
      throw error;
    }
  }
);

export default apiSlice.reducer;
